const getters = {
  organisations: state => state.organisations,
  organisation: state => state.organisation,
  loaded: state => state.loaded
};

export default getters;
